var render = function render(_c,_vm){return _c('div',{staticClass:"mb-1"},[_c('span',{staticClass:"secondary--text text--lighten-2 mr-1"},[_vm._t("title",function(){return [_vm._v(_vm._s(_vm.props.title))]})],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }